:host {
  display: block;
  width: 100%;

  .br-collapse {
    .trigger {
      display: flex;
      justify-content: center;
      align-items: center;

      &:not(:disabled):hover,
      &:not(:disabled):focus-visible {
        background-image: linear-gradient(rgb(var(--color-rgb), var(--hover)), rgb(var(--color-rgb), var(--hover)));
      }
    }

    .trigger-content {
      flex: 1 1 auto !important;
    }

    .content {
      transition: height 0.3s;
      overflow: hidden;
    }

    br-icon {
      color: var(--interactive);
    }
  }

  details {
    width: 100%;

    summary {
      list-style: none;
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      padding: 8px 12px;
      height: 48px;
      outline: none;

      &::-webkit-details-marker {
        display: none;
      }

      &:focus-visible {
        outline: var(--focus-width) var(--focus-style) var(--focus);
      }
    }
  }

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    border: 0;
  }
}
